import { Route } from 'react-router-dom'
import DatosUsuario from '../pages/usuario/DatosUsuario'
import ClaveUsuario from '../pages/usuario/ClaveUsuario'
import ProtectedRoute from './../components/ProtectedRoute'

const UserRoutes = () => (
  <>
    <Route path="/user" >
      <Route
        path="datos-usuario"
        element={
          <ProtectedRoute>
            <DatosUsuario />
          </ProtectedRoute>
        }
      />
      <Route
        path="clave-usuario"
        element={
          <ProtectedRoute>
            <ClaveUsuario />
          </ProtectedRoute>
        }
      />
    </Route>
  </>
)

export default UserRoutes
